import { useTranslation } from 'react-i18next'

import { EntityStatus } from '../../../Entity'
import { APPLICANT_STAGES } from '../../../RentalPortalApplicant'
import Text from '../../../Text'
import { Widget } from '../../../Widget'
import { useApplicantProfileContext } from '../RentalPortalApplicantProfile.hooks'

import { ApplicantProfileWidgetStageScreeningSkeleton } from './ApplicantProfileWidgetStageScreeningSkeleton'
import {
  QA_NAME_APPLICANT_PROFILE_STAGE_MIRROR,
  QA_NAME_APPLICANT_PROFILE_WIDGET_STAGE_SCREENING,
} from './RentalPortalApplicantProfileWidgetStageScreening.constants'
import { getIsApplicantInPool } from './RentalPortalApplicantProfileWidgetStageScreening.utils'

import * as styles from './RentalPortalApplicantProfileWidgetStageScreening.module.css'

// TODO: the screening checks come with the checklist, credit-check and compliance reads
function RentalPortalApplicantProfileWidgetStageScreening() {
  const { t } = useTranslation()

  const { applicantData, isInitiated } = useApplicantProfileContext()

  return (
    <Widget
      contentContainerProps={{
        Skeleton: ApplicantProfileWidgetStageScreeningSkeleton,
        className: styles.content,
      }}
      headerProps={{ contentProps: { actionsProps: { EditButton: null } } }}
      isSkeleton={!isInitiated || !applicantData}
      qaName={QA_NAME_APPLICANT_PROFILE_WIDGET_STAGE_SCREENING}
      title={t('RentalPortal.ApplicantProfileStageScreeningWidgetTitleKey')}
    >
      <div className={styles.stageRow}>
        <Text isSecondary className={styles.stageLabel}>
          {t('RentalPortal.ApplicantProfileStageMirrorLabelKey')}
        </Text>
        <EntityStatus
          id={applicantData?.stage}
          statuses={APPLICANT_STAGES}
          textQaName={QA_NAME_APPLICANT_PROFILE_STAGE_MIRROR}
        />
      </div>
      {getIsApplicantInPool(applicantData) ? (
        <Text isSecondary className={styles.poolHint}>
          {t('RentalPortal.ApplicantProfileScreeningPoolHintKey')}
        </Text>
      ) : null}
    </Widget>
  )
}

export default RentalPortalApplicantProfileWidgetStageScreening
